import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, UserX } from 'lucide-react';
import api from '../../utils/axios';
import { Card } from '../ui/card';

// K1: cuentas sin identificar con motivo CUIT_CONFLICTO (solo administradores), con link a la bandeja.
export const CuitConflictoHomeCard = () => {
  const navigate = useNavigate();
  const [total, setTotal] = useState(null);
  useEffect(() => {
    api.get('/cuentas-sin-identificar', { params: { estado: 'PENDIENTE', motivo: 'CUIT_CONFLICTO', limit: 1 } })
      .then((r) => setTotal(r.data.total ?? 0)).catch(() => setTotal(null));
  }, []);
  if (total === null) return null;
  return (
    <Card className={`mb-8 flex cursor-pointer items-center gap-4 p-4 transition-shadow hover:shadow-md ${total > 0 ? 'border-amber-300 bg-amber-50' : 'border-slate-200 bg-white'}`}
      onClick={() => navigate('/m/clientes/cuentas-sin-identificar?motivo=CUIT_CONFLICTO')} data-testid="home-cuit-conflicto">
      <div className={`rounded-lg p-2.5 ${total > 0 ? 'bg-amber-500' : 'bg-slate-200'}`}><UserX className="h-5 w-5 text-white" /></div>
      <div className="flex-1">
        <p className="text-sm font-semibold text-slate-800">Cuentas sin identificar con CUIT en conflicto</p>
        <p className="text-xs text-slate-500">El CUIT de los movimientos no coincide con el del padrón. Revisalas en la bandeja.</p>
      </div>
      <span className={`text-3xl font-bold tabular-nums ${total > 0 ? 'text-amber-700' : 'text-slate-400'}`} data-testid="home-cuit-conflicto-total">{total}</span>
      <ArrowRight className="h-5 w-5 text-slate-400" />
    </Card>
  );
};

export default CuitConflictoHomeCard;
